import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "page-filters pf-bar"
}
const _hoisted_3 = { class: "next-nodes-grid" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "next-node-card-top" }
const _hoisted_6 = { class: "next-node-card-name" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_confirm_delete = _resolveComponent("confirm-delete")!
  const _component_add_edit_onboarding = _resolveComponent("add-edit-onboarding")!
  const _component_onboarding_signatures = _resolveComponent("onboarding-signatures")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "page-bar" }, [
      _createElementVNode("div", null, [
        _createElementVNode("div", { class: "page-bar-sub" }, "Team"),
        _createElementVNode("div", { class: "page-bar-main" }, "Onboarding")
      ])
    ], -1)),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$store.state.routeLoaded ? 'slide-up view' : 'hide')
    }, [
      (_ctx.$store.state.user.teamHubRole == 'Admin')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addNewOnboarding())),
              class: "add-btn"
            }, "Add")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.onboardings, (onboarding, i) => {
            return _withDirectives((_openBlock(), _createElementBlock("div", {
              key: i,
              class: "next-node-card-wrap"
            }, [
              _createElementVNode("div", {
                class: "next-node-card",
                onClick: () => { _ctx.$router.push('/onboarding/'+onboarding.ID) }
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(onboarding.Name), 1),
                  (_ctx.$store.state.user.teamHubRole == 'Admin')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "next-node-menu-btn",
                        onClick: _withModifiers(($event: any) => (_ctx.toggleOnboardingMenu(onboarding, $event)), ["stop"])
                      }, [
                        _createVNode(_component_svg_icon, { icon: "dots" })
                      ], 8, _hoisted_7))
                    : _createCommentVNode("", true)
                ])
              ], 8, _hoisted_4),
              (_ctx.openOnboardingId == onboarding.ID)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "next-node-menu-dropdown",
                    style: _normalizeStyle(_ctx.onboardingMenuStyle),
                    onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    _createElementVNode("a", {
                      onClick: _withModifiers(($event: any) => (_ctx.onboardingMenuAction(() => _ctx.editOnboarding(onboarding))), ["prevent"])
                    }, "Edit", 8, _hoisted_8),
                    _createElementVNode("a", {
                      onClick: _withModifiers(($event: any) => (_ctx.onboardingMenuAction(() => _ctx.showSignaturesFn(onboarding))), ["prevent"])
                    }, "Signatures", 8, _hoisted_9),
                    _createElementVNode("a", {
                      onClick: _withModifiers(($event: any) => (_ctx.onboardingMenuAction(() => _ctx.deleteOnboarding(onboarding))), ["prevent"])
                    }, "Delete", 8, _hoisted_10)
                  ], 4))
                : _createCommentVNode("", true)
            ])), [
              [_vShow, !onboarding.hide]
            ])
          }), 128))
        ])
      ])
    ], 2),
    (_ctx.showConfirmDelete)
      ? (_openBlock(), _createBlock(_component_confirm_delete, {
          key: 0,
          onConfirm: _ctx.deleteConfirm,
          onCancel: _cache[2] || (_cache[2] = () => { _ctx.showConfirmDelete = false; }),
          msg: "Are you sure you would like to delete this onboarding?"
        }, null, 8, ["onConfirm"]))
      : _createCommentVNode("", true),
    (_ctx.showAddEdit)
      ? (_openBlock(), _createBlock(_component_add_edit_onboarding, {
          key: 1,
          onboardingToEdit: _ctx.onboardingToEdit,
          onClose: _cache[3] || (_cache[3] = () => { _ctx.getOnboardings(); _ctx.showAddEdit = false })
        }, null, 8, ["onboardingToEdit"]))
      : _createCommentVNode("", true),
    (_ctx.showSignatures)
      ? (_openBlock(), _createBlock(_component_onboarding_signatures, {
          key: 2,
          onClose: _cache[4] || (_cache[4] = () => { _ctx.showSignatures = false }),
          onboardingProp: _ctx.signaturesOnboarding
        }, null, 8, ["onboardingProp"]))
      : _createCommentVNode("", true)
  ]))
}